<div class="toast-container">
  @for (notification of notificationService.notifications$ | async; track notification) {
<div class="notification toast" [ngClass]="{
         'is-success': notification.type === 'success',
         'is-danger': notification.type === 'error',
         'is-info': notification.type === 'info',
         'is-warning': notification.type === 'warning'
       }">
      <button class="delete" (click)="remove(notification.id)"></button>
      <div class="toast-content">
        @if (notification.type === 'success') {
          <i class="ri-checkbox-circle-line"></i>
        }
        @if (notification.type === 'error') {
          <i class="ri-error-warning-line"></i>
        }
        @if (notification.type === 'info') {
          <i class="ri-information-line"></i>
        }
        @if (notification.type === 'warning') {
          <i class="ri-alert-line"></i>
        }
        <span>{{ notification.message }}</span>
      </div>
    </div>
  }
</div>